export default {
  routes: [
    {
      name: 'equip-types',
      path: '/directory/equip-types',
      component: () => import('./views/TheEquipTypes.vue'),

    },

    {
      name: 'equip-type',
      path: '/directory/equip-types/:uuid',
      component: () => import('./views/TheEquipType.vue'),
    },
  ]
}
